import type { CustomerCreatePayload } from "@/customTypings/customer/Customer";
import type { CustomerDeletedRestoreAvailableConflict } from "@/utils/customer/customerCreateConflict";
import {
    CUSTOMER_CREATE_CONFLICT,
    CustomerCreateConflictError,
    isCustomerDeletedRestoreAvailableConflict,
} from "@/utils/customer/customerCreateConflict";
import { createPayloadSpreadRestoreConfig } from "./createPayloadSpreadRestoreConfig";

export function createCustomerRestoreConfig<TDetail extends { id: string }>(options: {
    restoreDeletedWithCreateValues: (payload: CustomerCreatePayload & { id: string }) => Promise<TDetail>;
    onRestored: (detail: TDetail) => void;
}) {
    return createPayloadSpreadRestoreConfig<
        CustomerDeletedRestoreAvailableConflict,
        CustomerCreatePayload,
        CustomerCreatePayload & { id: string },
        TDetail,
        CustomerCreateConflictError
    >({
        ConflictErrorClass: CustomerCreateConflictError,
        isRestoreAvailable: isCustomerDeletedRestoreAvailableConflict,
        deletedRestoreAvailableCode: CUSTOMER_CREATE_CONFLICT.deletedRestoreAvailable,
        modalTitle: "Restore removed customer?",
        modalBody: () =>
            "A removed customer with this name already exists. Restore them with the information you just entered?",
        successLabel: (conflict) => conflict.existingName,
        restoreDeletedWithCreateValues: options.restoreDeletedWithCreateValues,
        onRestored: (detail) => options.onRestored(detail),
    });
}
